import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialFormData = {
  first_name: "",
  last_name: "",
  phone_number: "",
  agent_user_id: "",
  middle_name: "",
  id_type: "",
  id_number: "",
  location_address: "",
  location_gps_lat: "",
  location_gps_lon: "",
  device_imei: "",
};

function CustomerCreatePage() {
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://installmentzone.com/api";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.first_name || !formData.last_name || !formData.phone_number || !formData.agent_user_id) {
      toast.error("Please fill in all required fields (First Name, Last Name, Phone, Agent ID).");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/customers/create.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        toast.success(result.message || "Customer created successfully!");
        setFormData(initialFormData);
        setTimeout(() => navigate("/customers"), 2000);
      } else {
        toast.error(result.message || "Failed to create customer.");
      }
    } catch (err) {
      console.error("Error creating customer:", err);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formFields = [
    { name: "first_name", label: "First Name", type: "text", required: true },
    { name: "last_name", label: "Last Name", type: "text", required: true },
    { name: "phone_number", label: "Phone Number", type: "tel", required: true },
    { name: "agent_user_id", label: "Agent User ID", type: "number", required: true },
    { name: "middle_name", label: "Middle Name", type: "text" },
    { name: "id_type", label: "ID Type", type: "text" },
    { name: "id_number", label: "ID Number", type: "text" },
    { name: "location_address", label: "Location Address", type: "text" },
    { name: "location_gps_lat", label: "GPS Latitude", type: "text" },
    { name: "location_gps_lon", label: "GPS Longitude", type: "text" },
    { name: "device_imei", label: "Device IMEI", type: "text" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ToastContainer position="top-right" theme="colored" />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          padding: "35px",
          borderRadius: "15px",
          maxWidth: "700px",
          margin: "0 auto",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
          backdropFilter: "blur(6px)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "28px",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          Create Customer
        </h2>

        <form onSubmit={handleSubmit}>
          {formFields.map((field) => (
            <div
              key={field.name}
              style={{
                marginBottom: "18px",
              }}
            >
              <label
                htmlFor={field.name}
                style={{
                  display: "block",
                  marginBottom: "6px",
                  fontWeight: "600",
                  color: "#fff",
                }}
              >
                {field.label}{" "}
                {field.required && <span style={{ color: "#F87171" }}>*</span>}
              </label>
              <input
                type={field.type}
                id={field.name}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid rgba(255,255,255,0.4)",
                  background: "rgba(255,255,255,0.9)",
                  color: "#1E293B",
                  fontSize: "15px",
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.3s ease",
                }}
                onFocus={(e) =>
                  (e.target.style.borderColor = "#3B82F6")
                }
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255,255,255,0.4)")
                }
              />
            </div>
          ))}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              background: loading ? "#93C5FD" : "#1E3A8A",
              color: "#fff",
              padding: "14px",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              fontSize: "16px",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background 0.3s ease, transform 0.1s ease",
            }}
            onMouseEnter={(e) => {
              if (!loading) e.target.style.background = "#3B82F6";
            }}
            onMouseLeave={(e) => {
              if (!loading) e.target.style.background = "#1E3A8A";
            }}
          >
            {loading ? "Submitting..." : "Create Customer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CustomerCreatePage;
